import { translate } from "../locales/index.js";
import { ThemeButton } from "./ThemeButton.jsx";

export function ProjectOverview({ discussits, pending, onOpen, returning }) {
  return (
    <section className="project-overview section-panel">
      <div className="project-overview__content app__centred">
        <div className="project-overview__intro">
          <h2 className="project-overview__title">
            {translate(
              returning ? "overview.return.title" : "overview.start.title",
            )}
            {returning && (
              <>
                <br />
                {translate("overview.return.another_reaction")}
              </>
            )}
          </h2>
          {!returning && (
            <p className="project-overview__description">
              {translate("overview.start.description")}
            </p>
          )}
        </div>
        <div className="project-overview__buttons">
          {discussits.map((discussit) => (
            <ThemeButton
              key={discussit.key}
              discussit={discussit}
              disabled={pending !== null}
              onOpen={onOpen}
            />
          ))}
        </div>
      </div>
    </section>
  );
}
